import { FC, KeyboardEvent, useState, useRef } from 'react';
import { Input, Icon, Dropdown } from 'semantic-ui-react';
import { EventField, EventFilter } from '../../api/events';
import { useStateWithCallback } from '../../common';
import StructuredDropdown from '../../components/StructuredDropdown';


interface FilterSettingsProps {
    options: EventFilter;
    filter: EventFilter;
    onChange(filter: EventFilter): void;
}


const FilterSettings: FC<FilterSettingsProps> = ({ options, filter: initFilter, onChange }) => {
    const [filter, setFilter] = useStateWithCallback(initFilter);
    const [loading, setLoading] = useState(false);
    const catMenu = useRef<HTMLInputElement>(null)
    const [openSlide, setopenSlide] = useState(true);

    const closeOpenMenus = (e: any)=>{
        if(catMenu.current && openSlide && !catMenu.current.contains(e.target)){
          setLoading(false)
        }
    }
    document.addEventListener('mousedown',closeOpenMenus)

    const setFilterPromise = (newFilter: EventFilter) => {
        return new Promise((resolve: any, reject) => {
            setFilter(newFilter, resolve);
        });
    };

    const apply = (f?: any) => { onChange(f ?? [...filter]); };

    const clear = (key?: string) => {
        let textField = document.getElementById("objectId") as HTMLInputElement;
        textField.value = ''
        textField.click()
        return setFilterPromise([]);
    }

    const onFieldChange = (id: EventField, value?: any) => {
        if (value){
            value = value.replace(/\s+/g,' ')
            const clauses = value.split(' AND ')
            let newFilter: EventFilter = []

            if (clauses.length === 1){
                let operator = '='
                if (value.includes('%')){
                    operator='LIKE'
                }
    //         check if we need to use LIKE of Equal
                let tmp = clauses[0].split(' ')
                if (tmp.length === 1){
                    setLoading(false)
                    return setFilterPromise([{field: id, operator: operator, value: value}])
                }
                else{
                    let [id, operator, ...value] = clauses[0].split(' ')
                    value = value.join(' ')
                    setLoading(false)
                    return setFilterPromise([{field: id, operator: operator, value: value}])
                }
                setLoading(false)
                return setFilterPromise([{field: id, operator: operator, value: value}])
            }

            for (var clause of clauses ){
                let [id, operator, ...value] = clause.split(' ')
                value = value.join(' ')
                newFilter.push({field: id, operator: operator, value: value})
            }
            setLoading(false)
            return setFilterPromise(newFilter)
        }
        else{
            setLoading(false)
            return clear();
        }

    };

    const keyPress = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            apply();
        }
    };

    const changeLoading = () => {
        if (loading === true) {
            setLoading(false)
        }
        else{
            setLoading(true)
        }
    };

    const forceFilterRead = async (id: EventField, value: any) => {
        let textField = document.getElementById("objectId") as HTMLInputElement;
        if (value.isTrusted == false){
            setLoading(true)
            onFieldChange(id, textField.value)
        }
    }

    return (
        <div style={{ display: 'inline-block' }} ref={catMenu}>
            {Object.entries(options).map(entry => {
                const [ key, values ] = entry as [EventField, any];
                let filterValue = filter.find(e => e.field == key)?.value;
                if (filterValue){
                    filterValue = filterValue.replace('%', '')
                }

                if (values.constructor === Array) {
                    return (
                        <StructuredDropdown
                            key={key}
                            open={loading}
                            value={filterValue ?? ''}
                            icon='filter'
                            className='icon circular no-item-padding'
                            labeled
                            button
                            text={filterValue ?? key}
                            clearable
                            onClick={()=>changeLoading()}
                            onChange={() => { clear(key).then(apply); }}
                            itemClick={value => { onFieldChange(key, value).then(apply); }}
                            style={{ marginRight: '15px' }}
                            values={values}
                        />

                    );
                }
                else if (values === 'string') {
                    return (
                        <Input key={key} placeholder='Object id' icon iconPosition='left' style={{ width: '380px' }}>
                            <Icon name='search' />
                            <input
                                id={key}
                                style={{ borderRadius: '100px' }}
                                onChange={({ target: { value } }) => onFieldChange(key, value)}
                                onClick={(value) => forceFilterRead(key, value)}
                                onKeyUp={keyPress}
                            />
                        </Input>
                    );
                }
                else {
                    return false;
                }
            })}
        </div>
    )
};


export default FilterSettings;
